document.addEventListener('DOMContentLoaded', function() {
  var el = document.getElementById('delivery-date');
  if (el) {
    var date = new Date();
    var businessDaysToAdd = 3;
    var added = 0;
    while (added < businessDaysToAdd) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    // Exclude year from formatting
    var options = { weekday: 'long', month: 'long', day: 'numeric' };
    el.textContent = date.toLocaleDateString(undefined, options);
  }
});